const ITEMS = [
  ["enquiries", "Total enquiries"],
  ["new_enquiries", "New / pending callback"],
  ["contacted", "Contacted"],
  ["active_trips", "Active trips"],
  ["trips", "All trips"],
  ["georgia_trips", "Georgia trips"],
];

export function StatsGrid({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-4" data-testid="admin-stats">
      {ITEMS.map(([k, label]) => (
        <div key={k} className="rounded-3xl bg-cream/5 border border-cream/10 p-6" data-testid={`admin-stat-${k}`}>
          <p className="eyebrow text-cream/60">{label}</p>
          <p className={`mt-4 font-display text-5xl font-extrabold ${k === "new_enquiries" ? "text-terra-soft" : ""}`}>{stats?.[k] ?? "–"}</p>
        </div>
      ))}
    </div>
  );
}
